/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle-loading': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10 .4c.328 0 .6.24.651.553l.009.107v3.6a.66.66 0 01-1.311.107l-.01-.107v-3.6A.66.66 0 0110 .4zm9.6 9.6c0 .328-.24.6-.553.651l-.107.009h-3.6a.66.66 0 01-.107-1.311l.107-.01h3.6a.66.66 0 01.66.66zm-14.833.651A.66.66 0 004.66 9.34h-3.6l-.107.009a.66.66 0 00.107 1.31h3.6l.107-.008zm1.924 2.658a.66.66 0 01.07.852l-.07.082-2.546 2.545a.66.66 0 01-1.003-.851l.07-.082 2.545-2.546a.66.66 0 01.934 0zm-.857-6.554a.66.66 0 00.852-1.003L4.14 3.207l-.082-.07a.66.66 0 00-.851 1.003l2.545 2.546.082.07zM16.77 16.81a.66.66 0 01-.852.07l-.081-.07-2.546-2.546a.66.66 0 01.852-1.003l.081.07 2.546 2.546a.66.66 0 010 .933zm-6.119-1.456a.66.66 0 00-1.311.107v3.6l.009.107a.66.66 0 001.31-.107v-3.6l-.008-.107z" _fill="#1D3861"/>'
  }
})
